import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { StepIndicator } from '../components/StepIndicator';
import { ImageIcon, CheckCircleIcon, XCircleIcon, FilterIcon, SearchIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Master Creative', 'Campaign Setup', 'Select Creative', 'Styling Template', 'Variable Content', 'Generate', 'Review & Publish'];
const MOCK_CREATIVES = [{
  id: 1,
  dealer: 'Mumbai Central Motors',
  city: 'Mumbai',
  status: 'approved'
}, {
  id: 2,
  dealer: 'Delhi Auto Hub',
  city: 'Delhi',
  status: 'approved'
}, {
  id: 3,
  dealer: 'Bangalore Premium Cars',
  city: 'Bangalore',
  status: 'pending'
}, {
  id: 4,
  dealer: 'Pune Elite Motors',
  city: 'Pune',
  status: 'pending'
}, {
  id: 5,
  dealer: 'Chennai Auto World',
  city: 'Chennai',
  status: 'approved'
}, {
  id: 6,
  dealer: 'Hyderabad Car Center',
  city: 'Hyderabad',
  status: 'pending'
}, {
  id: 7,
  dealer: 'Kolkata Motors',
  city: 'Kolkata',
  status: 'approved'
}, {
  id: 8,
  dealer: 'Ahmedabad Auto Plaza',
  city: 'Ahmedabad',
  status: 'pending'
}];
export function ReviewPublish() {
  const navigate = useNavigate();
  const [creatives, setCreatives] = useState(MOCK_CREATIVES);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isPublishing, setIsPublishing] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const toggleApproval = (id: number) => {
    setCreatives(prev => prev.map(c => c.id === id ? {
      ...c,
      status: c.status === 'approved' ? 'pending' : 'approved'
    } : c));
  };
  const approveAll = () => {
    setCreatives(prev => prev.map(c => ({
      ...c,
      status: 'approved'
    })));
  };
  const filteredCreatives = creatives.filter(creative => {
    const matchesStatus = filterStatus === 'all' || creative.status === filterStatus;
    const matchesSearch = creative.dealer.toLowerCase().includes(searchQuery.toLowerCase()) || creative.city.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesStatus && matchesSearch;
  });
  const approvedCount = creatives.filter(c => c.status === 'approved').length;
  const handlePublish = () => {
    setIsPublishing(true);
    setTimeout(() => {
      setIsPublishing(false);
      setIsPublished(true);
    }, 2000);
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2007">
      <Sidebar data-id="element-2008" />
      <main className="flex-1" data-id="element-2009">
        <Header data-id="element-2010" />
        <StepIndicator currentStep={7} steps={STEPS} data-id="element-2011" />
        <div className="px-6 py-8" data-id="element-2012">
          <div className="max-w-6xl mx-auto" data-id="element-2013">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2014">
              Step 6: Review & Publish
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-2015">
              Review generated creatives and publish to Meta/Google
            </p>

            {!isPublished ? <div className="space-y-6" data-id="element-2016">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2017">
                  <div className="flex items-center justify-between mb-4" data-id="element-2018">
                    <h3 className="font-medium text-gray-800" data-id="element-2019">
                      Creative Gallery
                    </h3>
                    <div className="flex items-center space-x-3" data-id="element-2020">
                      <div className="relative" data-id="element-2021">
                        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-2022" />
                        <input type="text" placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm w-64" data-id="element-2023" />
                      </div>
                      <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-2024">
                        <option value="all" data-id="element-2025">All Status</option>
                        <option value="approved" data-id="element-2026">Approved</option>
                        <option value="pending" data-id="element-2027">Pending</option>
                      </select>
                      <button onClick={approveAll} className="px-4 py-2 bg-green-500 text-white rounded-md text-sm hover:bg-green-600" data-id="element-2028">
                        Approve All
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-4 gap-4" data-id="element-2029">
                    {filteredCreatives.map(creative => <div key={creative.id} className={`border-2 rounded-lg p-3 transition-all ${creative.status === 'approved' ? 'border-green-500 bg-green-50' : 'border-gray-200'}`} data-id="element-2030">
                        <div className="w-full h-32 bg-gray-100 rounded-lg mb-2 flex items-center justify-center relative" data-id="element-2031">
                          <ImageIcon className="text-gray-400" size={32} data-id="element-2032" />
                          <button onClick={() => toggleApproval(creative.id)} className="absolute top-2 right-2" data-id="element-2033">
                            {creative.status === 'approved' ? <CheckCircleIcon className="text-green-500" size={24} data-id="element-2034" /> : <XCircleIcon className="text-gray-400" size={24} data-id="element-2035" />}
                          </button>
                        </div>
                        <p className="text-sm font-medium text-gray-700" data-id="element-2036">
                          {creative.dealer}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2037">{creative.city}</p>
                      </div>)}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2038">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-2039">
                    Publish Settings
                  </h3>
                  <div className="space-y-4" data-id="element-2040">
                    <div data-id="element-2041">
                      <label className="flex items-center" data-id="element-2042">
                        <input type="checkbox" defaultChecked className="mr-3 w-4 h-4 text-blue-500" data-id="element-2043" />
                        <span className="text-sm text-gray-700" data-id="element-2044">
                          Push to Meta (Facebook & Instagram)
                        </span>
                      </label>
                    </div>
                    <div data-id="element-2045">
                      <label className="flex items-center" data-id="element-2046">
                        <input type="checkbox" defaultChecked className="mr-3 w-4 h-4 text-blue-500" data-id="element-2047" />
                        <span className="text-sm text-gray-700" data-id="element-2048">
                          Push to Google Ads
                        </span>
                      </label>
                    </div>
                    <div data-id="element-2049">
                      <label className="flex items-center" data-id="element-2050">
                        <input type="checkbox" defaultChecked className="mr-3 w-4 h-4 text-blue-500" data-id="element-2051" />
                        <span className="text-sm text-gray-700" data-id="element-2052">
                          Enable geo-targeting for each dealer
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-2053">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-2054">
                    Review Summary
                  </h4>
                  <div className="text-sm text-blue-800 space-y-1" data-id="element-2055">
                    <p data-id="element-2056">
                      <strong data-id="element-2057">{approvedCount}</strong> of{' '}
                      <strong data-id="element-2058">{creatives.length}</strong> creatives approved
                    </p>
                    <p data-id="element-2059">
                      Ready to launch geo-targeted campaigns across multiple
                      platforms
                    </p>
                  </div>
                </div>

                <div className="flex justify-between" data-id="element-2060">
                  <button onClick={() => navigate('/dealerization/step-5')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-2061">
                    Back
                  </button>
                  <button onClick={handlePublish} disabled={approvedCount === 0 || isPublishing} className="px-8 py-3 bg-green-500 text-white rounded-md font-medium hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-2062">
                    {isPublishing ? 'Publishing...' : 'Publish Campaigns'}
                  </button>
                </div>
              </div> : <div className="bg-white rounded-lg border border-gray-200 p-12 text-center" data-id="element-2063">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2064">
                  <CheckCircleIcon className="text-green-500" size={48} data-id="element-2065" />
                </div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3" data-id="element-2066">
                  Campaigns Published Successfully!
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-2067">
                  {approvedCount} dealer-specific campaigns are now live on Meta
                  and Google
                </p>
                <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto mb-8" data-id="element-2068">
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-2069">
                    <p className="text-3xl font-semibold text-gray-800" data-id="element-2070">
                      {approvedCount}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-2071">Campaigns Live</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-2072">
                    <p className="text-3xl font-semibold text-gray-800" data-id="element-2073">
                      35 min
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-2074">Total Time</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-2075">
                    <p className="text-3xl font-semibold text-gray-800" data-id="element-2076">99%</p>
                    <p className="text-sm text-gray-600" data-id="element-2077">Time Saved</p>
                  </div>
                </div>
                <div className="flex justify-center space-x-4" data-id="element-2078">
                  <button onClick={() => navigate('/dealerization')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-2079">
                    Start New Campaign
                  </button>
                  <button onClick={() => navigate('/')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600" data-id="element-2080">
                    View All Campaigns
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}